import { useCallback, useContext, useEffect, useState } from "react";
import { Box, Button, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";

import { callPostApi } from "../../function/ApiCallFunction";
import GradientLoader from "../../components/CommanComponents/GradientLoader";
import { DataContext } from "../../context/DataContext";


function DashboardReport() 
{
    const navigate = useNavigate();

    const {loginData }  = useContext(DataContext);
    const store_id      = loginData?.store_info?.store_id;

    const [startdate, setStartDate] = useState("");
    const [enddate, setEndDate] = useState("");
    const [loading, setLoading] = useState(false);

    const [datar, setDatar] = useState({
        total_generate_point: 0,
        total_redeem_point: 0,
        total_new_customer: 0,
        total_retain_customer: 0,
        total_sale_amount: 0,
        total_customer: 0,
    });
    
    /* -------------------- Utils -------------------- */
    const formatDate = (date) => {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };
    
    /* -------------------- API -------------------- */
    const dashboardApi = useCallback(async (start, end) =>
    {
        if (!store_id) return;
        try 
        {
            setLoading(true); 
            const payload = { mod: "CASHI_LOYALTY_DASHBOARD", data_arr: { store_id, startDate: start, endDate: end },};
            const apiResult = await callPostApi("cashi-dashboard", payload);
            if (apiResult.status === "200" && apiResult.data) 
            {
                const item = apiResult.data;

                setDatar({
                    total_generate_point  : item.total_generate_point  || 0,
                    total_redeem_point    : item.total_redeem_point    || 0,
                    total_new_customer    : item.total_new_customer    || 0,
                    total_retain_customer : item.total_retain_customer || 0,
                    total_sale_amount     : item.total_sale_amount     || 0,
                    total_customer        : item.total_customer        || 0,
                });
          }
        }
        catch (err) { console.error("Dashboard API error:", err);} 
        finally { setLoading(false); }  

    },[store_id]);

    /* -------------------- Initial Load -------------------- */
    useEffect(() => 
    {
        const today     = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1); // subtract one day :contentReference[oaicite:0]{index=0}
        
        const s = sessionStorage.getItem("startdate") || formatDate(yesterday);
        const e = sessionStorage.getItem("enddate")   || formatDate(today);

        sessionStorage.setItem("startdate", s);
        sessionStorage.setItem("enddate", e);

        setStartDate(s);
        setEndDate(e);

        dashboardApi(s, e);

    }, [dashboardApi]);

    /* -------------------- Handlers -------------------- */
    const handlesearch = () => {  dashboardApi(startdate, enddate); };

    const clearfilter = () => 
    {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);

        const s = formatDate(yesterday);
        const e = formatDate(today);

        sessionStorage.setItem("startdate", s);
        sessionStorage.setItem("enddate", e);
        
        setStartDate(s);
        setEndDate(e);

        dashboardApi(s, e);
    };

    const handleStartDateChange = (e) => 
    {
        setStartDate(e.target.value);
        sessionStorage.setItem("startdate", e.target.value);        
    };

    // Handler for end date
    const handleEndDateChange = (e) => 
    {
        setEndDate(e.target.value);
        sessionStorage.setItem("enddate", e.target.value);
        
    };

     /* -------------------- Navigation -------------------- */
    const gotosalereport     = () => { navigate("/saleReport",     { state: { startdate, enddate, }, }); };
    const gotocustomerreport = () => { navigate("/customerReport", { state: { startdate, enddate, }, }); };
  
    /* -------------------- Cards -------------------- */
    const cards = [
        { id: "1", title: "Points Rewarded",  value: datar.total_generate_point,    color: "blue",    },
        { id: "2", title: "Points Exchanged", value: datar.total_redeem_point,      color: "yellow",  },
        { id: "3", title: "New Users",        value: datar.total_new_customer,      color: "pink",    },
        { id: "4", title: "Users Retained",   value: datar.total_retain_customer,   color: "darkblue",},
        { id: "5", title: "Total Sale",       value: "₹" + datar.total_sale_amount, color: "orange",  },
        { id: "6", title: "Total Customers",  value: datar.total_customer,          color: "green",   },
    ];


  return (
    <Box>
        <Container>

          <Box sx={{ display: "flex", justifyContent: "start", mb: 2 }}>
            <Button  variant="contained"  sx={{ backgroundColor: "#000000", color: "#ffffff" }} onClick={() => navigate(-1)}> Back </Button>
          </Box>

          <div className="dashboard">
            
            <div className="date‐range text-center m-3">
                <input type="date" value={startdate} onChange={handleStartDateChange} />{" "}{" to "}
                <input type="date" value={enddate}   onChange={handleEndDateChange} />
                <Button variant="contained" sx={{ml: 1,background: "linear-gradient(195deg, #66BB6A, #43A047)",}} 
                    onClick={() => handlesearch()}>{" "}Apply{" "}</Button>
                <Button variant="contained"sx={{ml: 1,background: "linear-gradient(195deg, #d07f15ff, #d07f15ff)",}}
                    onClick={() => clearfilter()}>{" "}Clear{" "}</Button>
            </div>

            <div className="container">
              <div className="row">
                {cards.map((c, index) =>
                  c.id === "5" ? (
                    <div key={index} className="col-12 col-sm-6 col-md-6 mb-4">
                      <div className={`card card-${c.color} col-12`} style={{ cursor: "pointer" }} >
                        <div className="card-body" onClick={() => gotosalereport()} >
                          <div className="value"> <TrendingFlatIcon /> </div>
                          <div className="value">{c.value}</div>
                          <div className="title">{c.title}</div>
                        </div>
                      </div>
                    </div>
                  ) : c.id === "6" ? (
                    <div key={index} className="col-12 col-sm-6 col-md-6 mb-4">
                          <div className={`card card-${c.color} col-12`} style={{ cursor: "pointer" }}>
                          <div className="card-body" onClick={() => gotocustomerreport()} >
                          <div className="value"> <TrendingFlatIcon /> </div>
                          <div className="value">{c.value}</div>
                          <div className="title">{c.title}</div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div key={index} className="col-12 col-sm-6 col-md-6 mb-4">
                      <div className={`card card-${c.color} col-12`}>
                        <div className="card-body">
                          <div className="value">{c.value}</div>
                          <div className="title">{c.title}</div>
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </Container>
        {loading && <GradientLoader text="Loading" />}
    </Box>
  );
}

export default DashboardReport;
